export const VERIFICATION_METHODS = [
  { id: 1, name: 'Income Verification' },
  { id: 2, name: 'Net Worth Verification' },
  { id: 3, name: 'Accredited Letter' }
];

export const VERIFICATION_IDENTITY = [
  { id: 1, name: 'Income Verification' },
  { id: 2, name: 'Net Worth Verification (I)' },
  { id: 3, name: 'Net Worth Verification (II)' },
  { id: 4, name: 'Accredited Letter' }
];
